export default __webpack_public_path__ + "_/shared_modules/baui-ui/components/LoanAmountFilter/images/minus-sky-900-5f17e05de6faf01bf8e6ff6855873191.svg";